// Import necessary modules
import StatusSuccessIcon from "@atlaskit/icon/core/status-success";
import { clearAsset } from "../../../redux/actions/jiraAssetsActions";
import { clearWizard } from "../../../redux/actions/wizardActions";
import { useNavigate } from "react-router-dom";
import Button from "@atlaskit/button/new";
import { useDispatch, useSelector } from "react-redux";

const SuccessIndicator = ({ currentData }) => {
  const dispatch = useDispatch();
  const flows = useSelector((state) => state.integration.flows);
  const navigate = useNavigate();

  const onClickNavigate = (newPath) => {
    dispatch(clearWizard());
    dispatch(clearAsset());
    navigate(newPath);
  };

  const getFlow = () => {
    if (flows && flows.length > 0) {
      const flow = flows[flows.length - 1];
      return (
        <Button onClick={() => onClickNavigate("/integration/" + flow.id)} appearance="link">
          {flow.name}
        </Button>
      );
    }
    return <>Could not find flow</>;
  };

  if (currentData && currentData.ihubConfigIsCreated) {
    return (
      <>
        <br></br>
        <StatusSuccessIcon label="" color="#00875a" />
        Created Credentials
        <br></br>
        <StatusSuccessIcon label="" color="#00875a" />
        Created Integration Flow:
        {getFlow()}
      </>
    );
  }
  return null;
};

export default SuccessIndicator;
